// HTML
export default `<svg width="100%" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 15 15">
<g>
	<path fill="#0058A0" d="M15,11.761c0,0.387-0.314,0.701-0.701,0.701H0.701C0.313,12.461,0,12.148,0,11.761V3.239
		c0-0.387,0.314-0.701,0.701-0.701h13.599C14.687,2.539,15,2.852,15,3.239V11.761z"></path>
	<g>
		<g>
			<polygon fill="#FFFFFF" points="5.637,9.525 6.291,5.686 7.338,5.686 6.683,9.525 5.637,9.525 			"></polygon>
			<path fill="#FFFFFF" d="M10.478,5.78c-0.207-0.078-0.532-0.161-0.938-0.161c-1.034,0-1.763,0.521-1.769,1.267
				c-0.006,0.551,0.52,0.859,0.917,1.043c0.408,0.188,0.544,0.308,0.543,0.476C9.229,8.663,8.906,8.78,8.604,8.78
				c-0.418,0-0.641-0.058-0.984-0.202L7.485,8.518L7.338,9.377c0.244,0.107,0.696,0.2,1.166,0.205c1.1,0,1.814-0.515,1.822-1.312
				c0.004-0.437-0.275-0.769-0.878-1.043C9.082,7.049,8.857,6.931,8.86,6.751c0-0.159,0.19-0.33,0.6-0.33
				c0.342-0.005,0.59,0.069,0.783,0.147l0.094,0.044L10.478,5.78L10.478,5.78z"></path>
			<path fill="#FFFFFF" d="M13.162,5.689h-0.809c-0.25,0-0.438,0.068-0.548,0.318l-1.554,3.519h1.099c0,0,0.179-0.473,0.22-0.577
				c0.12,0,1.188,0.002,1.34,0.002c0.031,0.134,0.127,0.575,0.127,0.575h0.971L13.162,5.689L13.162,5.689z M11.871,8.164
				c0.087-0.221,0.417-1.073,0.417-1.073c-0.006,0.01,0.086-0.223,0.139-0.367l0.071,0.331c0,0,0.2,0.917,0.243,1.109H11.871
				L11.871,8.164z"></path>
			<path fill="#FFFFFF" d="M4.759,5.688L3.734,8.307L3.625,7.775C3.435,7.161,2.84,6.497,2.176,6.164l0.937,3.358L4.22,9.521
				l1.648-3.832H4.759L4.759,5.688z"></path>
			<path fill="#FAA61A" d="M2.784,5.686H1.096l-0.013,0.08c1.313,0.318,2.182,1.086,2.542,2.009L3.259,6.01
				C3.195,5.767,3.012,5.695,2.784,5.686L2.784,5.686z"></path>
		</g>
	</g>
</g>
</svg>
`